import React from 'react';

/**
 * @file LobbyList.tsx
 * @description
 * Component to display a list of game summaries in the lobby.
 */

interface GameItem {
  code: string;
  playersCount: number;
}

interface LobbyListProps {
  title: string;
  games: GameItem[];
  onJoin: (code: string) => void;
}

const LobbyList: React.FC<LobbyListProps> = ({ title, games, onJoin }) => {
  return (
    <div style={{ marginBottom: '1.5rem' }}>
      <h2>{title}</h2>
      {games.length === 0 ? (
        <p>No games available.</p>
      ) : (
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {games.map((game) => (
            <li
              key={game.code}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '0.5rem',
                border: '1px solid #ccc',
                borderRadius: '4px',
                marginBottom: '0.5rem',
              }}
            >
              <span>
                <strong>{game.code}</strong> ({game.playersCount}{' '}
                player{game.playersCount !== 1 ? 's' : ''})
              </span>
              <button onClick={() => onJoin(game.code)}>Join</button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LobbyList;